<div class="flex flex-col items-center max-w-sm mx-auto text-center">
  <h1 class="mt-3 text-2xl font-semibold text-gray-800 md:text-3xl">
    Page not found
  </h1>
  <p class="mt-4 text-gray-500">The page you are looking for doesn't exist.</p>
  <div class="flex items-center w-full mt-6 gap-x-3 shrink-0 sm:w-auto">
    <a routerLink="/" mat-raised-button color="primary"> Go Back </a>
  </div>
</div>
